export const mapMigrationReadinessStatusToDisplay = (
  readinessPercentage: number,
): {variant:'success' | 'error' | 'orange' | 'default' | 'info' | 'warning' | undefined, text:
    string} => {
  if (readinessPercentage === 100) {
    return { variant: 'success', text: 'Migration Ready' };
  } else if (readinessPercentage >= 75) {
    return { variant: 'success', text: `${readinessPercentage}% Complete` };
  } else if (readinessPercentage >= 50) {
    return { variant: 'info', text: `${readinessPercentage}% Complete` };
  } else if (readinessPercentage >= 25) {
    return { variant: 'warning', text: `${readinessPercentage}% Complete` };
  } else {
    return { variant: 'error', text: `${readinessPercentage}% Complete` };
  }
};

export default mapMigrationReadinessStatusToDisplay;
